import type { SiteCardWithHealth } from './siteCardsGroup/siteCardsGroup.types.ts';

export const groupSitesByServiceSupport = (
  sites: readonly SiteCardWithHealth[],
  supportedSiteIds: ReadonlySet<string>,
  hiddenUnsupportedSiteId?: string
): { supportedSites: SiteCardWithHealth[]; unsupportedSites: SiteCardWithHealth[] } => {
  const supportedSites: SiteCardWithHealth[] = [];
  const unsupportedSites: SiteCardWithHealth[] = [];

  for (const item of sites) {
    if (supportedSiteIds.has(item.site.id)) {
      supportedSites.push(item);
    } else if (item.site.id !== hiddenUnsupportedSiteId) {
      unsupportedSites.push(item);
    }
  }

  return { supportedSites, unsupportedSites };
};
